import React, { useEffect, useState } from "react";
import "./Schoollist.css";
import { useNavigate } from "react-router-dom";
import { Domain, Workspace } from "../../path";
import useGet from "../../Hooks/useGet";
import { useDispatch } from "react-redux";
import { Set_Loader } from "../../Redux/Action/LoaderAction";
const Schoollist = () => {
  const Navigation = useNavigate();
  const Dispatch = useDispatch();
  const [SchoolList, setSchoolList] = useState([]);

  const SchoolData = useGet(`${Workspace[Domain].API_Path}/school_list`);

  const Get_School_List = () => {
    SchoolData.refetch("");
  };
  const School_Handler = (id) => {
    Navigation(`/schooldetail/${btoa(id)}`);
  };

  useEffect(() => {
    Get_School_List();
    window.addEventListener("popstate", (e) => {
      // window.history.go(1);
    });
    return () => {
      setSchoolList([]);
    };
  }, []);
  // SCHOOL LIST
  useEffect(() => {
    if (SchoolData.data != null) {
      setSchoolList(SchoolData.data?.body?.school_data);
      Dispatch(Set_Loader(false));
    }
  }, [SchoolData.data]);

  return (
    <div className="h-full school-list-container">
      <h2 className="text-center py-3 text-2xl font-semibold max-[440px]:text-md">
        Welcome to Different Learners
      </h2>

      {SchoolList?.length > 0 && (
        <div className="school-list-wrapper flex flex-col items-center overflow-y-auto h-5/6 pb-5">
          {SchoolList?.map((item, index) => {
            return (
              <button
                key={index}
                className="bg-[#f79221] w-4/12 my-2 py-3 text-md font-medium text-[white] rounded-md max-[440px]:w-11/12 max-[440px]:text-md"
                onClick={() => School_Handler(item?.school_id)}
              >
                {item?.school_name}
              </button>
            );
          })}
        </div>
      )}

      {SchoolList?.length == 0 && (
        <p className="text-center font-semibold mt-5 text-xl text-[tomato]">
          No school found
        </p>
      )}
    </div>
  );
};

export default Schoollist;
